import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/bpm'

class BpmApiClient {
	async buscarListagemPerfilPorAtividade(filtros) {
		const url = SearchUrlParamBuilder.montarUrl(`${URL_PATH}/buscarPerfisPorAtividade`, filtros)
		return await axios.get(url)
	}

	async buscarProximasAtividades(filtros) {
		const url = SearchUrlParamBuilder.montarUrl(`${URL_PATH}/buscarProximasAtividades`, filtros)
		return await axios.get(url)
	}

	async encaminharAtividade(body) {
		await axios.post(`${URL_PATH}/encaminharAtividade`, body)
	}
}

export default new BpmApiClient()
